import { api } from "../Configurations/axios";

const CreateOpportunityYear = async (year: string, companyId: string, userEmail: string) => {
    try {
        const result = await api.post('/OpportunityMapping/CreateYear', { year: year, companyId: companyId, userEmail: userEmail });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutSectorOnOpportunity = async (id: string, userEmail: string, sector: string, sectorOther: string, companyId: string) => {
    try {
        const result = await api.put('/OpportunityMapping/PutSectorOnOpportunity', { id: id, userEmail: userEmail, sector: sector, sectorOther: sectorOther, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutOpenDateOnOpportunity = async (id: string, userEmail: string, openDate: Date, companyId: string) => {
    try {
        const result = await api.put('/OpportunityMapping/PutOpenDateOnOpportunity', { id: id, userEmail: userEmail, openDate: openDate, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutGuaranteeOnOpportunity = async (id: string, userEmail: string, guarantee: string[], guaranteeOther: string, companyId: string) => {
    try {
        const result = await api.put('/OpportunityMapping/PutGuaranteeOnOpportunity', { id: id, userEmail: userEmail, guarantee: guarantee, otherGuarantee: guaranteeOther, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutGuaranteeValueOnOpportunity = async (id: string, userEmail: string, guaranteeValue: number, companyId: string) => {
    try {
        const result = await api.put('/OpportunityMapping/PutGuaranteeValueOnOpportunity', { id: id, userEmail: userEmail, guaranteeValue: guaranteeValue, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllOpportunitiesMapping = async (companyId: string) => {
    try {
        const result = await api.get(`/OpportunityMapping/GetAllOpportunitiesMapping/${companyId}`);
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteOpportunityYear = async (year: string, companyId: string) => {
    try {
        const result = await api.delete('/OpportunityMapping/DeleteYear', { data: { year: year, companyId: companyId } });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    CreateOpportunityYear,
    GetAllOpportunitiesMapping,
    PutSectorOnOpportunity,
    PutOpenDateOnOpportunity,
    PutGuaranteeOnOpportunity,
    PutGuaranteeValueOnOpportunity,
    DeleteOpportunityYear
}